<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // ID
        b-col(md="4")
          b-form-group(label="ID", label-for="ID", description="")
            validation-provider(name="ID", rules="required", v-slot="{ errors }")
              b-form-input(
                id="id",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}

      // Button
      b-row
        b-col(cols="12", class="text-right")
          b-button(
            variant="success",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}

  audit-log-table(
    v-if="isEdit && data",
    :history="data.history || []",
    :field-translations="{ name: 'ID' }"
  )
</template>

<script>
import { ref, toRefs } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import vSelect from 'vue-select'
import AuditLogTable from '@/components/AuditLogTable.vue'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    AuditLogTable,
  },

  props: {
    data: { type: Object, required: true },
    isSubmitting: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const form = ref(null)

    const validateForm = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateForm()
        .then(() => emit('submit', toRefs(props.data)))
        .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    return {
      required,
      form,
      validateAndSubmit,
    }
  },
}
</script>

<style scoped>

</style>
